import Vue from 'vue'
import App from './App'
import VueRouter from 'vue-router' 
import VueResource from 'vue-resource' 
import Feed from './components/Feed'
import Hello from './components/Hello'
import Mint from 'mint-ui'

//注册插件 
Vue.use(VueResource) 
Vue.use(VueRouter) 
Vue.use(Mint);

const router = new VueRouter() 
// 路由map 
router.map({ 
	'/feed': { 
		component: Feed
	},
	'/app': { 
		component: App
	}  
}) 

router.redirect({ 
	'*': '/app' 
}) 

router.start(App, '#app')

/* eslint-disable no-new */
new Vue({
  el: 'body',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js